const getFeaturesFromGeoJson = (
  geoJson,
  filter = datum => datum,
  map = datum => datum
) => {
  if (!geoJson.features) {
    return []
  }

  const data = geoJson.features
    .map(feature => feature.properties)
    .filter(filter)
    .map(map)

  return data
}

export default getFeaturesFromGeoJson



// WEBPACK FOOTER //
// ./src/utility/getFeaturesFromGeoJson.js